import {ref, toRefs, reactive, computed } from 'vue';
import store from '../../../../../common/infrastructure/almacen';
import { Actions, Mutations } from '../../../../../common/infrastructure/almacen/enums/StoreEnums';
import { IapApplicationConfiguration } from '../../../../builder/application/domain/iapApplicationConfiguration';
import { IapCatalog } from '../../../catalog/domain/iapCatalog';
import { AppLayoutConfig } from '../../../../builder/template/infrastructure/prime/AppLayoutConfig';

import { IServiceUserOption } from '../../../../../../src/entidades/builderMaster/user/application/IServiceUserOption';
import { IapmUserOption } from '../../../../../../src/entidades/builderMaster/user/domain/iapmUserOption';
import { TYPES } from '../../../../../common/domain/types';

import { IapmUser } from '@ilinium/shared/src/entidades/builderMaster/user/domain/iapmUser';
import { Container } from 'inversify';
import HelperWorkFlow from '../../../workflow/infrastructure/functions/helperWorkFlow';
import TemplateTypeConst from '@ilinium/shared/src/common/domain/constantes/TemplateTypeConst'


const layoutState = reactive({
    staticMenuDesktopInactive: false,
    overlayMenuActive: false,
    sidebarActive: false,
    anchored: false,
    overlaySubmenuActive: false,
    profileSidebarVisible: false,
    configSidebarVisible: false,
    staticMenuMobileActive: false,
    menuHoverActive: false,
    activeMenuItem: null
});

var componentThemes = ref([
    { name: 'indigo', color: '#00594f' },
    { name: 'blue', color: '#3B82F6' },
    { name: 'purple', color: '#8B5CF6' },
    { name: 'teal', color: '#14B8A6' },
    { name: 'cyan', color: '#06b6d4' },
    { name: 'green', color: '#10b981' },
    { name: 'orange', color: '#f59e0b' },
    { name: 'pink', color: '#d946ef' }
]);

const apolloDarkComponentThemes = ref([
    { name: 'blue', color: '#93c5fd' },
    { name: 'cyan', color: '#67e8f9' },
    { name: 'green', color: '#6ee7b7' },
    { name: 'indigo', color: '#a5b4fc' },
    { name: 'orange', color: '#fcd34d' },
    { name: 'pink', color: '#fda4af' },
    { name: 'purple', color: '#c4b5fd' },
    { name: 'teal', color: '#5eead4' }
]);

const apolloLightComponentThemes = ref([
    { name: 'blue', color: '#3B82F6' },
    { name: 'cyan', color: '#06b6d4' },
    { name: 'green', color: '#10b981' },
    { name: 'indigo', color: '#00594f' },
    { name: 'orange', color: '#f59e0b' },
    { name: 'pink', color: '#d946ef' },
    { name: 'purple', color: '#8B5CF6' },
    { name: 'teal', color: '#14B8A6' }
]);

const layoutConfig = reactive({
    template:'',
    scale: 14,
    menuMode: 'static',
    menuTheme: 'colorScheme',
    colorScheme: 'light',
    inputStyle: 'outlined',
    ripple: false,
    componentTheme: 'indigo',
    topbarTheme: 'indigo',
    menuProfilePosition: 'end',
    RTL: false,
});


export function useLayoutBuilder () {

    function getAppLayoutConfig(appUserLayoutOptions:IapmUserOption[]): void {
        var appLayoutCfg:AppLayoutConfig = {template:'', scale:0, menuMode:'', menuTheme:'', colorScheme:'', inputStyle:'', ripple:false, componentTheme:'', topbarTheme:'', menuProfilePosition:'', RTL:false};
        var appCfg:IapApplicationConfiguration[] = store.getters.getAppConfig;
    
        // Configuración Layout del usuario
        appLayoutCfg = getUserLayoutConfig(appUserLayoutOptions);

        //AppConfig Template
        appLayoutCfg.template = getLayoutTemplateAppConfig(appCfg);

        //AppConfig Theme
        appLayoutCfg.colorScheme = getLayoutThemeAppConfig(appCfg);

        //AppConfig Style
        appLayoutCfg.componentTheme = getLayoutStyleAppConfig(appCfg);
    
        // Añadir la configuración Layout al storage
        store.commit(Mutations.SET_APPLAYOUTCONFIG, appLayoutCfg) 

        setLayoutConfig ();

        // Actualizar el Template configurado (Aqui soporta refresco de pagina Ctrl-F5)
        changeAppTemplate();

    }

    function setLayoutConfig () : void {
        var appLayoutCfg = store.getters.getAppLayoutConfig as AppLayoutConfig;

        layoutConfig.template = appLayoutCfg.template;
        layoutConfig.scale = appLayoutCfg.scale;
        layoutConfig.menuMode = appLayoutCfg.menuMode;
        layoutConfig.menuTheme = appLayoutCfg.menuTheme;
        layoutConfig.colorScheme = appLayoutCfg.colorScheme;
        layoutConfig.inputStyle = appLayoutCfg.inputStyle;
        layoutConfig.ripple = appLayoutCfg.ripple;
        layoutConfig.componentTheme = appLayoutCfg.componentTheme;
        layoutConfig.topbarTheme = appLayoutCfg.topbarTheme;
        layoutConfig.menuProfilePosition = appLayoutCfg.menuProfilePosition;
        layoutConfig.RTL = appLayoutCfg.RTL;
        
    }

    function changeAppTemplate () : void {
        var appLayoutCfg = store.getters.getAppLayoutConfig as AppLayoutConfig;
        changeTemplateLayout(appLayoutCfg.template, appLayoutCfg.componentTheme, appLayoutCfg.colorScheme);
        changeTemplateTheme(appLayoutCfg.template, appLayoutCfg.componentTheme, appLayoutCfg.colorScheme);
    }

    const changeLayout = (template: string) => {
        const layoutLink = document.getElementById('layout-css');
        const layoutHref = layoutLink?.getAttribute('href');

        const currentHrefTemplate = getTemplate(layoutHref ?? '').toString();
        
        const newHref = layoutHref?.replace(currentHrefTemplate,template);
        replaceLink(layoutLink, newHref, () => {
            //store.commit(Mutations.SET_APPLAYOUTCONFIG, appLayoutCfg);
        });
    };

    const changeTheme = (template: string, theme: string, colorScheme: string) => {
        const themeLink = document.getElementById('theme-css');
        const themeHref = themeLink?.getAttribute('href');

        const currentHrefTemplate = getTemplate(themeHref ?? '').toString();
        const currentHrefTheme = getTheme(themeHref ?? '').toString();
        const currentHrefColorScheme = getColorSchema(themeHref ?? '').toString();

        const currentThemeColorScheme = 'theme-' + currentHrefColorScheme + '/' + currentHrefTheme;
        const newThemeColorScheme = 'theme-' +  colorScheme + '/' + theme;

        const newHref = themeHref?.replace(currentHrefTemplate,template).replace(currentThemeColorScheme, newThemeColorScheme);
        replaceLink(themeLink, newHref, () => {
            //store.commit(Mutations.SET_APPLAYOUTCONFIG, appLayoutCfg);
        });
    };

    const changeScale = (scale:number) => {
        document.documentElement.style.fontSize = scale + 'px';
    };
    
    const changeTemplateLayout = (template: string, theme: string, colorScheme: string) => {
        const layoutLink = document.getElementById('layout-css');
        const layoutHref = layoutLink?.getAttribute('href');
        const path = process.env.VUE_APP_PUBLIC_PATH;
        var newHref = layoutHref;

        switch (template) {
            case TemplateTypeConst.PRIME_PRESTIGE:
                    newHref = path + '/prestige/layout/css/layout-' + theme + '.css';
                    break;
            case TemplateTypeConst.PRIME_PRESTIGEIS:
                    newHref = path + '/prestige_intrasoft/layout/css/layout.css';
                    break;
            case TemplateTypeConst.PRIME_PRESTIGE_INTRASOFT:
                newHref = path + '/prestige_intrasoft/layout/css/layout.css';
                break;
            case TemplateTypeConst.PRIME_ULTIMA:
                newHref = path + '/ultima/layout/preloading.css';
                break;
            case TemplateTypeConst.PRIME_APOLLO:
                newHref = path + '/apollo/layout/preloading.css';
                break;
            default:
                break;
        }

        newHref = newHref?.replace('//','/');        

        replaceLink(layoutLink, newHref, () => {
            //store.commit(Mutations.SET_APPLAYOUTCONFIG, appLayoutCfg);
        });
    };

    const changeTemplateTheme = (template: string, theme: string, colorScheme: string) => {

        const themeLink = document.getElementById('theme-css');
        const themeHref = themeLink?.getAttribute('href');

        const path = process.env.VUE_APP_PUBLIC_PATH;
        var newHref = themeHref;

        switch (template) {
            case TemplateTypeConst.PRIME_PRESTIGE:
                newHref = path + '/prestige/theme/theme-' + theme + '.css';
                break;
            case TemplateTypeConst.PRIME_PRESTIGEIS:
                newHref = path + '/prestige_intrasoft/theme/theme.css';
                break;
            case TemplateTypeConst.PRIME_PRESTIGE_INTRASOFT:
                newHref = path + '/prestige_intrasoft/theme/theme.css';
                break;
            case TemplateTypeConst.PRIME_ULTIMA:
                newHref = path + '/ultima/theme/theme-' + colorScheme + '/' + theme + '/theme.css';
                break;
            case TemplateTypeConst.PRIME_APOLLO:
                newHref = path + '/apollo/theme/theme-' + colorScheme + '/' + theme + '/theme.css'
                break;
            default:
                break;
        }

        newHref = newHref?.replace('//','/');

        replaceLink(themeLink, newHref, () => {
            //store.commit(Mutations.SET_APPLAYOUTCONFIG, appLayoutCfg);
        });
    };

    async function setAppLayoutConfig (appLayoutCfg:AppLayoutConfig, container:Container) : Promise<void> {
        var appUserLayoutOptions:IapmUserOption[] = [];
        const user = store.getters.getCurrentUser;
        const applicationId = user.applicationId;
        const applicationVersion = user.applicationVersion;
        const data: IapmUserOption[] = buildAppConfigData(user.id, appLayoutCfg);

        const _srvUsrOpt = container?.get<IServiceUserOption>(TYPES.USER_OPTION_SERVICE);
        await _srvUsrOpt?.setUserOptionsData(applicationId, applicationVersion, data)
        .then((response: any) => {
            appUserLayoutOptions = response.data;
        })
        .finally(() => {
        });   
    }
    
    async function resetAppLayoutConfig (appLayoutCfg:AppLayoutConfig, container:Container | undefined) : Promise<void> {
        var appUserLayoutOptions:IapmUserOption[] = [];
        const user = store.getters.getCurrentUser;
        const applicationId = user.applicationId;
        const applicationVersion = user.applicationVersion;
        const data: IapmUserOption[] = buildAppConfigData(0, appLayoutCfg);

        // Resetear las opciones de configuración del Layout para todos los usuarios !!!!
        resetOptions(applicationId, applicationVersion, data, container);

        getAppLayoutConfig(appUserLayoutOptions);
    }

   const resetOptions = (applicationId:number, applicationVersion:number, data:IapmUserOption[], container:Container | undefined) : void => {
        const _srvUsrOpt = container?.get<IServiceUserOption>(TYPES.USER_OPTION_SERVICE);
        _srvUsrOpt?.resetUserOptionsData(applicationId, applicationVersion, data)
        .then((response: any) => {
        })
        .catch((error) => {
            console.log(error);
        })
        .finally(() => {
        });   
    }

    const buildAppConfigData = (userId:number, appLayoutCfg:AppLayoutConfig): IapmUserOption[] => {
        const data: IapmUserOption[] = [];
        var value:IapmUserOption 
        
        value = {userId:userId, optionId:'AppLayoutTemplate', value:appLayoutCfg.template};
        data.push(value);
        value = {userId:userId, optionId:'AppLayoutScale', value:appLayoutCfg.scale.toString()};
        data.push(value);
        value = {userId:userId, optionId:'AppLayoutMenuMode', value:appLayoutCfg.menuMode};
        data.push(value);
        value = {userId:userId, optionId:'AppLayoutMenuTheme', value:appLayoutCfg.menuTheme};
        data.push(value);
        value = {userId:userId, optionId:'AppLayoutColorScheme', value:appLayoutCfg.colorScheme};
        data.push(value);
        value = {userId:userId, optionId:'AppLayoutInputStyle', value:appLayoutCfg.inputStyle};
        data.push(value);
        value = {userId:userId, optionId:'AppLayoutRipple', value:appLayoutCfg.ripple.toString()};
        data.push(value);

        value = {userId:userId, optionId:'AppLayoutComponentTheme', value:appLayoutCfg.componentTheme};
        data.push(value);
        value = {userId:userId, optionId:'AppLayoutTopBarTheme', value:appLayoutCfg.topbarTheme};
        data.push(value);
        value = {userId:userId, optionId:'AppLayoutMenuProfilePosition', value:appLayoutCfg.menuProfilePosition};
        data.push(value);

        value = {userId:userId, optionId:'AppLayoutRTL', value:appLayoutCfg.RTL.toString()};
        data.push(value);

        return data;
    };

    const replaceLink = (linkElement:any, href:any, onComplete:any) => {
        if (!linkElement || !href) {
            return;
        }

        const id = linkElement.getAttribute('id');
        const cloneLinkElement = linkElement.cloneNode(true);

        cloneLinkElement.setAttribute('href', href);
        cloneLinkElement.setAttribute('id', id + '-clone');

        linkElement.parentNode.insertBefore(cloneLinkElement, linkElement.nextSibling);

        cloneLinkElement.addEventListener('load', () => {
            linkElement.remove();

            const element = document.getElementById(id); // re-check
            element && element.remove();

            cloneLinkElement.setAttribute('id', id);
            onComplete && onComplete();
        });
    };

    function getTemplate (href:string): string {
        var hrefTemplate:string = '';

        if (href.search('apollo') != -1) {
            hrefTemplate='apollo';
        }
        else {
            if (href.search('ultima') != -1) {
                hrefTemplate='ultima';
            }
            else {
                if (href.search('prestige') != -1) {
                    hrefTemplate='prestige';
                }
                else {
                    hrefTemplate=''; 
                }
            }
        }
        return hrefTemplate;
    }

    function getTheme (href:string): string {
        var theme ='';
        href = href.substring(href.lastIndexOf('-') + 1,href.lastIndexOf('/'))
        theme = href.substring(href.lastIndexOf('/')+1)
        return theme;
    }

    function getColorSchema (href:string): string {
        var colorSchema='';
        href = href.substring(href.lastIndexOf('-') + 1,href.lastIndexOf('/'))
        colorSchema = href.substring(0, href.lastIndexOf('/'))
        return colorSchema;
    }

    function getUserLayoutConfig(appUserLayoutOptions:IapmUserOption[]): AppLayoutConfig {
        var appLayoutCfg:AppLayoutConfig = {template:'', scale:0, menuMode:'', menuTheme:'', colorScheme:'', inputStyle:'', ripple:false, componentTheme:'', topbarTheme:'', menuProfilePosition:'', RTL:false};

        // Inicializar Layout
        appLayoutCfg = initLayoutConfig();

        // Cargar configuración Layout del usuario
        if (appUserLayoutOptions.length > 0) {
            for (let idx = 0; idx < appUserLayoutOptions.length; idx++) {
                const userOption = appUserLayoutOptions[idx];

                //User Template
                if (userOption.optionId == 'AppLayoutTemplate') {
                    appLayoutCfg.template = userOption.value ?? appLayoutCfg.template;
                }

                //User Scale
                if (userOption.optionId == 'AppLayoutScale') {
                    //appLayoutCfg.scale = parseInt(userOption.value ?? appLayoutCfg.scale.toString());
                    appLayoutCfg.scale = Number(userOption.value ?? appLayoutCfg.scale.toString());
                }

                //User MenuMode
                    if (userOption.optionId == 'AppLayoutMenuMode') {
                    appLayoutCfg.menuMode = userOption.value ?? appLayoutCfg.menuMode;
                }

                //User MenuTheme
                if (userOption.optionId == 'AppLayoutMenuTheme') {
                    appLayoutCfg.menuTheme = userOption.value ?? appLayoutCfg.menuTheme;
                }

                //User ColorScheme
                if (userOption.optionId == 'AppLayoutColorScheme') {
                    appLayoutCfg.colorScheme = userOption.value ?? appLayoutCfg.colorScheme;
                }

                //User InputStyle
                if (userOption.optionId == 'AppLayoutInputStyle') {
                    appLayoutCfg.inputStyle = userOption.value ?? appLayoutCfg.inputStyle;
                }

                //User Ripple
                if (userOption.optionId == 'AppLayoutRipple') {
                    appLayoutCfg.ripple=false;
                    if (userOption.value == 'true') {
                        appLayoutCfg.ripple = true;
                    }
                }

                //User ComponentTheme
                if (userOption.optionId == 'AppLayoutComponentTheme') {
                    appLayoutCfg.componentTheme = userOption.value ?? appLayoutCfg.componentTheme;
                }

                //User TopBarTheme
                if (userOption.optionId == 'AppLayoutTopBarTheme') {
                    appLayoutCfg.topbarTheme = userOption.value ?? appLayoutCfg.topbarTheme;
                }

                //User MenuProfilePosition
                if (userOption.optionId == 'AppLayoutMenuProfilePosition') {
                    appLayoutCfg.menuProfilePosition = userOption.value ?? appLayoutCfg.menuProfilePosition;
                }

                //User RTL
                if (userOption.optionId == 'AppLayoutRTL') {
                    appLayoutCfg.RTL=false;
                    if (userOption.value == 'true') {
                        appLayoutCfg.RTL = true;
                    }
                }

            }
        }    
        
        return appLayoutCfg;
    }

    function initLayoutConfig(): AppLayoutConfig {
        var appLayoutCfg:AppLayoutConfig = 
            {
                template:'', 
                scale:14, 
                menuMode:'static', 
                menuTheme:'colorScheme', 
                colorScheme:'light', 
                inputStyle:'outlined', 
                ripple:false, 
                componentTheme:'indigo', 
                topbarTheme:'', 
                menuProfilePosition:'', 
                RTL:false};
             
        switch (appLayoutCfg.template) {
            case TemplateTypeConst.PRIME_PRESTIGE:
                appLayoutCfg.template = 'prestige';
                break;
            case TemplateTypeConst.PRIME_PRESTIGEIS:
                appLayoutCfg.template = 'prestigeis';
                break;                
            case TemplateTypeConst.PRIME_PRESTIGE_INTRASOFT:
                appLayoutCfg.template = 'prestige-intrasoft';
                break;
            case TemplateTypeConst.PRIME_ULTIMA:
                appLayoutCfg.template = 'ultima';
                appLayoutCfg.menuTheme = 'light';
                appLayoutCfg.topbarTheme = 'indigo';
                appLayoutCfg.menuProfilePosition = 'end';
                break;
            case TemplateTypeConst.PRIME_APOLLO:
                appLayoutCfg.template = 'apollo';
                appLayoutCfg.menuTheme = 'colorScheme';
                appLayoutCfg.topbarTheme = '';
                appLayoutCfg.menuProfilePosition = '';
                break;
        }

        return appLayoutCfg;
    }

    function getLayoutTemplateAppConfig (appCfg:IapApplicationConfiguration[]): string {
        //AppConfig Template
        var template:string='apollo';
        let appCfgTemplate = appCfg.filter((x: { idKeyType: string; }) => {return x.idKeyType == 'appconfig-template'})[0];
        if (appCfgTemplate) {
            template = appCfgTemplate.keyValue ?? 'apollo';  
            if (template) {
                template = template.replace('templarend-prime','');
            }
        }
        return template;
    }

    function getLayoutThemeAppConfig (appCfg:IapApplicationConfiguration[]): string {
        //AppConfig Theme
        var theme:string='light'
        let appCfgTheme = appCfg.filter((x: { idKeyType: string; }) => {return x.idKeyType == 'appconfig-template-theme'})[0];
        if (appCfgTheme) {
            theme = appCfgTheme.keyValue ?? 'light';  
            if (theme) {
                theme = theme.substring(theme.lastIndexOf('-') + 1);
            }
        }
        return theme;
    }

    function getLayoutStyleAppConfig (appCfg:IapApplicationConfiguration[]): string {
        //AppConfig Style
        var style:string='indigo'
        let appCfgStyle = appCfg.filter((x: { idKeyType: string; }) => {return x.idKeyType == 'appconfig-template-theme-style'})[0];
        if (appCfgStyle) {
            style = appCfgStyle.keyValue ?? 'indigo';  
            if (style) {
                style = style.substring(style.lastIndexOf('-') + 1);
            }
        }
        return style;
    }
 
    return {
        layoutConfig: toRefs(layoutConfig),
        getAppLayoutConfig,
        changeAppTemplate,
        setAppLayoutConfig,
        resetAppLayoutConfig,
        getLayoutTemplateAppConfig,
        getLayoutThemeAppConfig,
        getLayoutStyleAppConfig
    }
}